import React from "react";
import { Control, FieldValues, Path, RegisterOptions, useController } from "react-hook-form";
import Checkbox from "./Checkbox";

interface Props<$FieldValues extends FieldValues> extends React.ComponentProps<typeof Checkbox> {
  name: Path<$FieldValues>;
  rules?: RegisterOptions;
  control: Control<$FieldValues>;
}

const ControlledCheckbox = <$FieldValues extends FieldValues>(
  props: Props<$FieldValues>,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { name, control, rules, ...rest } = props;
  const { field } = useController({
    name: props.name,
    control: props.control,
    rules: props.rules,
  });

  return (
    <Checkbox
      {...rest}
      {...field}
      value={undefined}
      checked={field.value}
      onCheckedChange={field.onChange}
      ref={ref}
    />
  );
};

export default React.forwardRef(ControlledCheckbox);
